<template>
  <div class="row m-0 top_menu p-0" :class="{ 'bottom_shadow': position != 'top' }" v-if="isLoggedIn && shopDetails && shopIds.length">
    <transition name="slide">
      <div v-if="isNavOpen" class="mobile_menu">
        <div class="row full_height justify-content-center align-items-center">
          <div class="col-12">
            <sidebar-menu @toggleNavbar="toggleNavbar"></sidebar-menu>
          </div>
        </div>
      </div>
    </transition>
    <div class="col-lg-2 d-none d-lg-block p-0">
      <sidebar-menu></sidebar-menu>
    </div>
    <div class="col-12 col-lg-10 h-100 ">
      <div class="row m-0 h-100 align-items-center">
        <div @click="toggleNavbar" class="col-auto p-0 above_all d-lg-none">
          <span class="material-icons edit_icon" :class="{'ninety_degree': isNavOpen}">
            menu
          </span>
        </div>
        <div class="col-8 col-sm-7 col-md-4 col-lg-4 col-xl-3 d-lg-none">
          <router-link to="/shop" class="navbar-brand mr-auto">
            <img :src="shopDetails.logo" v-if="shopDetails.logo" class="logo img-fluid"/>
            <span v-else>{{ shopDetails.name }}</span>
          </router-link>
        </div>
        <div class="col p-0 text-right">

          <!-- <profile-menu :user="currentUserDetails" v-else>
          </profile-menu> -->
          <profile-menu v-if="isLoggedIn">
          </profile-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex'
export default {
  props: {
    position: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  components: {
    'sidebar-menu': () => import('@/components/SidebarMenu.vue'),
    'profile-menu': () => import('@/components/common/UserMenuItem.vue')
  },
  data () {
    return {
      isNavOpen: false
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'shopDetails', 'shopIds']),
    userEmail () {
      return this.isLoggedIn ? this.currentUser.email : ''
    },
    currentPath () {
      return this.$route.path
    }
  },
  methods: {
    ...mapActions(['logout']),
    toggleNavbar () {
      this.isNavOpen = !this.isNavOpen
    }
  }
}
</script>

<style scoped>
.top_menu {
  background-color: var(--light-color);
  height: 80px;
  color: var(--dark-color);
  position: sticky;
  top: 0;
  z-index: 99;
  padding: 0.5rem 1rem;
}
.dark-mode .top_menu {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
.bottom_shadow {
  -webkit-box-shadow: 0 0 8px 1px var(--dark-color-03);
  box-shadow: 0 0 8px 1px var(--dark-color-03);
}
.dark-mode .bottom_shadow {
  background-color: var(--dark-color);
  border-bottom: 1px solid var(--dark-color);
}

.li-pointer {
  cursor: pointer;
}
.ninety_degree {
  transform: rotate(90deg);
}
.li-pointer:hover {
  cursor: pointer;
}
.logo {
  max-height: 55px; /* must be a better way */
}
.ion {
  font-size: 30px;
}
.mobile_menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  background-color: var(--light-color-09);
  color: var(--dark-color);
}
.dark-mode .mobile_menu {
  background-color: var(--dark-color-09);
  color: var(--light-color);
}
.mobile_menu .nav-link {
  display: block;
  padding: 0;
}
.close_icon {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 25vw;
  text-align: right;
}
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter {
  transform: translateX(-100%);
  opacity: 1;
}
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 1;
}
.full_height {
  height: 100vh;
}
.above_all {
  z-index: 999;
  position: relative;
}
@media (min-width: 992px) {
  .top_menu {
    height: 60px;
  }
}
</style>
